import { ReactElement } from 'react';
import { FieldArray, FieldArrayRenderProps, useFormikContext } from 'formik';
import Grid from '@mui/material/Grid';
import { Box, Fab, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import classNames from 'classnames';
import get from 'lodash/get';

// Components
import { FormikInputField, FormikNumberField } from 'components/ContinuousImprovement/PureFormElements';

// Styles
import styles from 'components/TextboxRepeater/TextboxRepeater.module.scss';

// Types
import { IBCTSpecialty } from 'core/models';
interface IProps {
  disabled?: boolean;
  formikKey: string;
  labelPrompt?: string;
}
export const PracticeAreasRepeater = (props: IProps): ReactElement => {
  const { disabled, formikKey, labelPrompt } = props;
  const { setFieldTouched, values } = useFormikContext();
  const formikAccess: IBCTSpecialty[] = get(values, formikKey);

  return (
    <FieldArray
      name={formikKey}
      render={(arrayHelpers: FieldArrayRenderProps): ReactElement => {
        return (
          <Grid container spacing={3}>
            {formikAccess?.map((_: IBCTSpecialty, idx: number): ReactElement => {
              return (
                <Grid component={Box} key={idx} sx={{ display: 'flex' }}>
                  <Box>
                    <FormikInputField
                      formikKey={`${formikKey}.${idx}.name`}
                      label={labelPrompt}
                      name={`${formikKey}.${idx}.name`}
                    />
                  </Box>
                  <Grid component={Box} sx={{ ml: 2 }} size={{ sm: 3 }}>
                    <FormikNumberField
                      formikKey={`${formikKey}.${idx}.sortOrder`}
                      label="Sort Order"
                      min={1}
                      step={1}
                    />
                  </Grid>
                  <Box component={Box} sx={{ alignSelf: 'center', mt: 3, ml: 2 }}>
                    <IconButton aria-label="remove" onClick={(): void => arrayHelpers.remove(idx)} size="small">
                      <ClearIcon fontSize="inherit" />
                    </IconButton>
                  </Box>
                </Grid>
              );
            })}
            <Box sx={{ display: 'flex', pt: 2, pb: 2 }}>
              <Box sx={{ mr: 2 }}>
                <Fab
                  aria-label="add another instance"
                  className={classNames(
                    {
                      [styles.disabled]: disabled,
                    },
                    styles['add-btn'],
                  )}
                  disabled={disabled}
                  onClick={(): void => {
                    arrayHelpers.push({ sortOrder: formikAccess.length + 1 });
                    setFieldTouched(formikKey, true);
                  }}
                  size="small"
                >
                  <AddIcon color="inherit" />
                </Fab>
              </Box>
              <Box sx={{ pt: 0.5 }}>Add Another Instance</Box>
            </Box>
          </Grid>
        );
      }}
    />
  );
};
